// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-select-dropdown__item.selected[data-v-79361839]{font-weight:400;color:#606266}", ""]);
// Exports
module.exports = exports;
